const ja = {
	'快跟我一起来<br />SuperChinese学中文吧!': '一緒にSuperChinese<br />で中国語を勉強しよう！',
	'零基础任性学': 'ゼロから楽に学べる',
	'听说读写全面提升': '聴解、読解、会話、作文　スキルアップ',
	'趣味对话': '対話を楽しむ',
	'100+日常对话等你来': '100以上の日常対話話題',
	'智能AI': 'AI智能',
	'个性化学习推荐，由浅入深系统学': '易しいところから初めるシステムスタディー',
	'趣味对话等你来': '楽しい対話が待ってる',
	'立即打开': '今すぐ開ける',
	'我在SuperChinese<br />已累计学习{day}天': 'SuperChineseでの<br />累計学習日数 <span>{day}</span> 日',
	'我在SuperChinese<br />已连续学习{day}天': 'SuperChineseでの<br />すでに <span>{day}</span> 日間学習しました',
	'学习生词': '学習した語彙',
	'学习语法': '学習した文法',
	'口语练习': '練習した口語',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>回',
	'点击右上角的按钮,选择在浏览器中打开': '右上のこれをタップ,ブラウザで開くを選択',
	'邀请码': '招待コード',
	'用邀请码注册，参与抽大奖': 'アプリのダウンロード後に新規登録し、招待コードの記入が完了すると、抽選のチャンスがもらえます',
}
export default ja;